export default __webpack_public_path__ + "static/media/amazon.23df6bd1.png";